import { useQuery, useQueryClient } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { ICustomerName } from "../models/ICustomer";
import { DefaultResponseWithData } from "../models/system";

export default function useWilmaCustomers() {
  const { get } = useApiHelper();
  const queryClient = useQueryClient();

  const customers = useQuery({
    queryKey: ["customers"],
    queryFn: () => get<DefaultResponseWithData<ICustomerName[]>>("/customer/names"),
    refetchInterval: 1000 * 60 * 5, // 5 minutes
  });

  return {
    customers,
  };
}